const path = require('./images/___.png').split('/');

export const json = {
  v: '5.6.9',
  fr: 30,
  ip: 0,
  op: 240,
  w: 636,
  h: 636,
  nm: '预合成 1',
  ddd: 0,
  assets: [
    {
      id: 'image_0',
      w: 702,
      h: 678,
      u: '/img/',
      p: path[path.length - 1],
      e: 0,
    },
  ],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 4,
      nm: '“图层 2/螺旋背景”轮廓',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.681, y: 1 },
              o: { x: 0.322, y: 0 },
              t: 0,
              s: [318, 318, 0],
              to: [-2.667, -1.333, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.688, y: 1 },
              o: { x: 0.339, y: 0 },
              t: 120,
              s: [302, 310, 0],
              to: [0, 0, 0],
              ti: [-2.667, -1.333, 0],
            },
            { t: 240, s: [318, 318, 0] },
          ],
          ix: 2,
        },
        a: { a: 0, k: [318, 318, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [23.043, 8.106],
                    [13.738, 20.914],
                    [-24.959, -18.189],
                    [-45.497, 0.308],
                    [40.568, 11.799],
                  ],
                  o: [
                    [-23.043, -8.106],
                    [-13.739, -20.914],
                    [24.96, 18.189],
                    [26.391, 0],
                    [-40.567, -11.799],
                  ],
                  v: [
                    [-11.518, 34.718],
                    [-81.283, -25.603],
                    [-52.285, -4.926],
                    [68.632, 34.718],
                    [11.535, 34.718],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: '路径 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.447058853449, 0.972549079446, 0.929411824544, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: '填充 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [243.115, 496.272], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: '变换',
            },
          ],
          nm: '组 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 244,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 2,
      ty: 4,
      nm: '“图层 3/螺旋背景”轮廓',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.681, y: 1 },
              o: { x: 0.322, y: 0 },
              t: 0,
              s: [318, 318, 0],
              to: [1, -2.167, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.688, y: 1 },
              o: { x: 0.339, y: 0 },
              t: 120,
              s: [324, 305, 0],
              to: [0, 0, 0],
              ti: [1, -2.167, 0],
            },
            { t: 240, s: [318, 318, 0] },
          ],
          ix: 2,
        },
        a: { a: 0, k: [318, 318, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [4.674, 9.024],
                    [14.046, -21.554],
                    [1.343, -2.834],
                    [-16.641, 25.498],
                  ],
                  o: [
                    [-4.673, -9.024],
                    [-11.173, 17.146],
                    [-3.51, 7.407],
                    [16.64, -25.497],
                  ],
                  v: [
                    [31.01, -34.093],
                    [-14.969, 2.016],
                    [-32.173, 35.71],
                    [-18.88, 17.255],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: '路径 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.447058853449, 0.972549079446, 0.929411824544, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: '填充 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [133.972, 145.892], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: '变换',
            },
          ],
          nm: '组 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 244,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 3,
      ty: 4,
      nm: '“图层 4/螺旋背景”轮廓',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.681, y: 1 },
              o: { x: 0.322, y: 0 },
              t: 0,
              s: [318, 318, 0],
              to: [-0.333, -2, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.688, y: 1 },
              o: { x: 0.339, y: 0 },
              t: 120,
              s: [316, 306, 0],
              to: [0, 0, 0],
              ti: [-0.333, -2, 0],
            },
            { t: 240, s: [318, 318, 0] },
          ],
          ix: 2,
        },
        a: { a: 0, k: [318, 318, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-0.244, 2.771],
                    [-2, -8.314],
                    [11.534, 3.514],
                  ],
                  o: [
                    [0.244, -2.771],
                    [2, 8.314],
                    [-11.535, -3.515],
                  ],
                  v: [
                    [-21.336, -3.558],
                    [19.581, 0],
                    [2.474, 1.856],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: '路径 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.952941236309, 0.674509803922, 0.415686304429, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: '填充 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [336.596, 64.654], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: '变换',
            },
          ],
          nm: '组 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 244,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 4,
      ty: 4,
      nm: '“图层 5/螺旋背景”轮廓',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.681, y: 1 },
              o: { x: 0.322, y: 0 },
              t: 0,
              s: [318, 318, 0],
              to: [0.833, -2.667, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.688, y: 1 },
              o: { x: 0.339, y: 0 },
              t: 120,
              s: [323, 302, 0],
              to: [0, 0, 0],
              ti: [0.833, -2.667, 0],
            },
            { t: 240, s: [318, 318, 0] },
          ],
          ix: 2,
        },
        a: { a: 0, k: [318, 318, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0.532, 4.305],
                    [-9.009, -11.641],
                    [32.81, -0.074],
                  ],
                  o: [
                    [-0.532, -4.305],
                    [9.008, 11.642],
                    [-32.81, 0.074],
                  ],
                  v: [
                    [-60.512, 10.536],
                    [52.036, -3.201],
                    [6.419, 7.6],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: '路径 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.952941236309, 0.674509803922, 0.415686304429, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: '填充 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [291.235, 44.371], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: '变换',
            },
          ],
          nm: '组 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 244,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 5,
      ty: 4,
      nm: '“图层 6/螺旋背景”轮廓',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.681, y: 1 },
              o: { x: 0.322, y: 0 },
              t: 0,
              s: [318, 318, 0],
              to: [0, -3, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.688, y: 1 },
              o: { x: 0.339, y: 0 },
              t: 120,
              s: [318, 300, 0],
              to: [0, 0, 0],
              ti: [0, -3, 0],
            },
            { t: 240, s: [318, 318, 0] },
          ],
          ix: 2,
        },
        a: { a: 0, k: [318, 318, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-8.03, 28.554],
                    [-57.758, 34.854],
                    [35.648, -12.192],
                    [-1.544, -2.428],
                    [-27.635, 2.567],
                    [-14.54, 0.388],
                    [0, 0],
                    [-0.032, -1.104],
                    [1.024, -0.127],
                    [22.421, -12.871],
                    [9.145, -36.849],
                    [1.02, 0.253],
                    [-0.105, 0.948],
                    [9.571, -21.031],
                    [2.951, -41.73],
                    [0, 0],
                    [2.204, 0.155],
                    [-0.004, 2.103],
                  ],
                  o: [
                    [11.656, -37.35],
                    [45.638, -25.39],
                    [-35.648, 12.192],
                    [1.543, 2.428],
                    [17.702, -2.288],
                    [0, 0],
                    [1.104, -0.032],
                    [0.029, 1.032],
                    [-36.772, 4.485],
                    [-43.422, 24.927],
                    [-0.253, 1.02],
                    [-0.925, -0.229],
                    [4.417, -39.84],
                    [-15.424, 33.892],
                    [0, 0],
                    [-0.154, 2.204],
                    [-2.098, -0.147],
                    [0.084, -28.502],
                  ],
                  v: [
                    [-96.322, 32.162],
                    [-8.117, -91.09],
                    [51.916, -109.707],
                    [-14.416, -71.187],
                    [58.048, -100.058],
                    [106.411, -104.072],
                    [106.411, -104.073],
                    [108.468, -102.132],
                    [106.713, -100.089],
                    [17.924, -74.054],
                    [-61.472, 33.483],
                    [-63.778, 34.871],
                    [-65.211, 32.814],
                    [-72.942, 4.601],
                    [-100.504, 118.034],
                    [-100.503, 118.034],
                    [-104.773, 121.744],
                    [-108.493, 117.746],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: '路径 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.282352941176, 0.58431372549, 0.937254961799, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: '填充 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [155.526, 173.276], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: '变换',
            },
          ],
          nm: '组 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 244,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 6,
      ty: 4,
      nm: '“图层 7/螺旋背景”轮廓',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.681, y: 1 },
              o: { x: 0.322, y: 0 },
              t: 0,
              s: [318, 318, 0],
              to: [-3, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.688, y: 1 },
              o: { x: 0.339, y: 0 },
              t: 120,
              s: [300, 318, 0],
              to: [0, 0, 0],
              ti: [-3, 0, 0],
            },
            { t: 240, s: [318, 318, 0] },
          ],
          ix: 2,
        },
        a: { a: 0, k: [318, 318, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [11.021, -35.467],
                    [155.426, 0],
                    [50.814, 59.028],
                    [-56.773, -4.209],
                    [-25.547, 0],
                    [-59.11, 90.627],
                    [6.016, -17.719],
                    [-8.015, 18.307],
                  ],
                  o: [
                    [-11.021, 35.467],
                    [-85.505, -0.24],
                    [37.403, 34.277],
                    [85.16, 6.314],
                    [25.548, 0],
                    [6.016, -11.08],
                    [16.698, -13.514],
                    [12.022, -27.46],
                  ],
                  v: [
                    [206.888, -43.567],
                    [-16.435, 94.246],
                    [-220.913, 5.344],
                    [-79.649, 63.073],
                    [-7.013, 51.147],
                    [171.821, -29.014],
                    [171.821, -19.055],
                    [208.891, -66.786],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: '路径 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.952941236309, 0.674509803922, 0.415686304429, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: '填充 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [346.322, 493.769], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: '变换',
            },
          ],
          nm: '组 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 244,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 7,
      ty: 4,
      nm: '“图层 8/螺旋背景”轮廓',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.681, y: 1 },
              o: { x: 0.322, y: 0 },
              t: 0,
              s: [318, 318, 0],
              to: [-1.667, -1.333, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.688, y: 1 },
              o: { x: 0.339, y: 0 },
              t: 120,
              s: [308, 310, 0],
              to: [0, 0, 0],
              ti: [-1.667, -1.333, 0],
            },
            { t: 240, s: [318, 318, 0] },
          ],
          ix: 2,
        },
        a: { a: 0, k: [318, 318, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [30.712, -37.235],
                    [37.001, -27.098],
                    [59.971, 10.341],
                    [32.816, 59.754],
                    [5.662, 39.934],
                    [0.16, -5.43],
                    [8.019, 7.727],
                    [-2.872, 50.511],
                    [0.914, -4.445],
                    [-21.559, -42.596],
                    [-15.453, -20.17],
                    [0, 0],
                    [1.316, -1.007],
                    [1.018, 0.488],
                    [32.449, 51.538],
                    [-1.129, -5.398],
                    [-33.913, -40.192],
                    [-41.472, -7.713],
                    [-27.333, 61.723],
                    [-3.581, 60.71],
                    [15.159, 23.322],
                    [0, 0],
                    [1.39, -0.902],
                    [-0.683, -1.366],
                  ],
                  o: [
                    [24.161, 48.22],
                    [-44.083, 53.445],
                    [-47.726, 34.953],
                    [-48.636, -8.387],
                    [-19.03, -34.654],
                    [-0.782, -5.516],
                    [-1.579, 53.603],
                    [-16.414, -22.539],
                    [0.269, -4.722],
                    [-11.569, 56.268],
                    [11.558, 21.434],
                    [0, 0],
                    [1.007, 1.315],
                    [-0.896, 0.687],
                    [-29.265, -14.03],
                    [-2.738, -4.349],
                    [6.496, 31.07],
                    [59.02, 63.878],
                    [150.376, 18.901],
                    [8.849, -19.983],
                    [0, -33.243],
                    [0, 0],
                    [-0.902, -1.39],
                    [-1.281, 0.832],
                    [0, 0],
                  ],
                  v: [
                    [238.962, -176.25],
                    [229.135, -48.067],
                    [153.415, 51.523],
                    [-15.323, 81.898],
                    [-165.605, -30.639],
                    [-202.002, -133.906],
                    [-205.161, -134.326],
                    [-196.019, -52.758],
                    [-221.619, -171.138],
                    [-223.659, -172.215],
                    [-204.006, -19.684],
                    [-163.489, 42.722],
                    [-163.486, 42.719],
                    [-164.045, 46.924],
                    [-167.164, 47.248],
                    [-259.736, -51.103],
                    [-265.767, -49.799],
                    [-204.006, 66.638],
                    [-36.363, 162.109],
                    [236.617, 30.806],
                    [266.896, -94.376],
                    [244.157, -179.224],
                    [244.159, -179.224],
                    [240.009, -180.107],
                    [238.96, -176.249],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: '路径 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.968627510819, 0.145098039216, 0.521568627451, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: '填充 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [322.071, 433.59], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: '变换',
            },
          ],
          nm: '组 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 244,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 8,
      ty: 4,
      nm: '“图层 9/螺旋背景”轮廓',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.681, y: 1 },
              o: { x: 0.322, y: 0 },
              t: 0,
              s: [318, 318, 0],
              to: [1, -3.667, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.688, y: 1 },
              o: { x: 0.339, y: 0 },
              t: 120,
              s: [324, 296, 0],
              to: [0, 0, 0],
              ti: [1, -3.667, 0],
            },
            { t: 240, s: [318, 318, 0] },
          ],
          ix: 2,
        },
        a: { a: 0, k: [318, 318, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-0.238, -5.619],
                    [30.249, -7.704],
                    [0.721, 10.015],
                    [0, 2.311],
                    [-11.592, 9.317],
                  ],
                  o: [
                    [-8.289, 29.578],
                    [3.601, -9.245],
                    [-0.72, -3.851],
                    [-1.441, -19.259],
                    [12.096, -11.392],
                  ],
                  v: [
                    [27.552, -33.935],
                    [-27.552, 39.555],
                    [-12.427, 17.213],
                    [-21.789, 14.901],
                    [12.128, -12.904],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: '路径 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.447058853449, 0.972549079446, 0.929411824544, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: '填充 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [514.637, 419.168], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: '变换',
            },
          ],
          nm: '组 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 244,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 9,
      ty: 4,
      nm: '“图层 10/螺旋背景”轮廓',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.681, y: 1 },
              o: { x: 0.322, y: 0 },
              t: 0,
              s: [318, 318, 0],
              to: [-3.333, -0.333, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.688, y: 1 },
              o: { x: 0.339, y: 0 },
              t: 120,
              s: [298, 316, 0],
              to: [0, 0, 0],
              ti: [-3.333, -0.333, 0],
            },
            { t: 240, s: [318, 318, 0] },
          ],
          ix: 2,
        },
        a: { a: 0, k: [318, 318, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [7.387, -0.463],
                    [33.569, 34.799],
                    [-48.726, 5.421],
                  ],
                  o: [
                    [-45.698, 1.575],
                    [42.14, 21.653],
                    [11.673, -1.743],
                  ],
                  v: [
                    [52.996, 23.171],
                    [-71.982, -25.52],
                    [60.309, 20.098],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: '路径 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [1, 0.941176530427, 0.941176530427, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: '填充 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [326.632, 486.234], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: '变换',
            },
          ],
          nm: '组 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 244,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 10,
      ty: 4,
      nm: '“图层 11/螺旋背景”轮廓',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.681, y: 1 },
              o: { x: 0.322, y: 0 },
              t: 0,
              s: [318, 318, 0],
              to: [-2, -2, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.688, y: 1 },
              o: { x: 0.339, y: 0 },
              t: 120,
              s: [306, 306, 0],
              to: [0, 0, 0],
              ti: [-2, -2, 0],
            },
            { t: 240, s: [318, 318, 0] },
          ],
          ix: 2,
        },
        a: { a: 0, k: [318, 318, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [20.287, 3.618],
                    [2.099, -1.448],
                    [-4.197, 0],
                    [-18.157, -0.732],
                  ],
                  o: [
                    [-19.588, 3.853],
                    [-2.098, -0.724],
                    [2.799, -5.066],
                    [18.188, 0.723],
                    [0, 0],
                  ],
                  v: [
                    [32.895, -0.959],
                    [-25.868, 0],
                    [-33.563, 2.171],
                    [-20.271, -3.618],
                    [33.563, -1.439],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: '路径 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [1, 0.941176530427, 0.941176530427, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: '填充 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [415.451, 168.549], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: '变换',
            },
          ],
          nm: '组 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 244,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 11,
      ty: 4,
      nm: '“图层 12/螺旋背景”轮廓',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.681, y: 1 },
              o: { x: 0.322, y: 0 },
              t: 0,
              s: [318, 318, 0],
              to: [-0.667, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.688, y: 1 },
              o: { x: 0.339, y: 0 },
              t: 120,
              s: [314, 318, 0],
              to: [0, 0, 0],
              ti: [-0.667, 0, 0],
            },
            { t: 240, s: [318, 318, 0] },
          ],
          ix: 2,
        },
        a: { a: 0, k: [318, 318, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-4.958, -0.057],
                    [-2.862, -1.549],
                    [31.487, -85.233],
                    [57.965, -11.623],
                    [52.241, 55.015],
                    [-10.019, 84.458],
                    [-35.781, -39.517],
                    [-23.616, 51.915],
                    [-66.552, -45.717],
                    [-11.45, -18.596],
                    [-30.056, 2.325],
                    [-20.754, 10.848],
                    [-4.294, 3.1],
                    [-7.156, 39.517],
                    [67.818, 21.694],
                  ],
                  o: [
                    [4.959, 0.058],
                    [81.581, 37.968],
                    [-21.469, 57.339],
                    [-72.277, 14.722],
                    [-56.534, -58.888],
                    [9.303, 50.365],
                    [-13.597, -51.14],
                    [-2.147, 77.485],
                    [17.891, 12.397],
                    [19.322, 31.769],
                    [22.9, -2.324],
                    [6.44, -3.099],
                    [29.34, -23.245],
                    [14.312, -75.16],
                    [-10.655, -5.597],
                  ],
                  v: [
                    [93.197, -182.727],
                    [108.059, -179.071],
                    [187.492, 53.383],
                    [64.405, 168.061],
                    [-133.105, 110.723],
                    [-208.961, -119.408],
                    [-164.592, 27.814],
                    [-177.474, -132.58],
                    [-95.177, 73.53],
                    [-45.799, 111.497],
                    [50.093, 137.068],
                    [110.921, 106.073],
                    [128.811, 106.073],
                    [181.767, 8.443],
                    [93.197, -168.996],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: '路径 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.533333333333, 0.36862745098, 0.964705942191, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: '填充 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [367.366, 342.385], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: '变换',
            },
          ],
          nm: '组 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 244,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 12,
      ty: 4,
      nm: '“图层 13/螺旋背景”轮廓',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.681, y: 1 },
              o: { x: 0.322, y: 0 },
              t: 0,
              s: [318, 318, 0],
              to: [-1.839, -1.154, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.688, y: 1 },
              o: { x: 0.339, y: 0 },
              t: 120,
              s: [306.968, 311.078, 0],
              to: [0, 0, 0],
              ti: [-1.839, -1.154, 0],
            },
            { t: 240, s: [318, 318, 0] },
          ],
          ix: 2,
        },
        a: { a: 0, k: [318, 318, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [9.724, -12.476],
                    [9.594, 2.887],
                    [3.067, 26.56],
                    [-9.706, 25.208],
                    [-10.378, 5.894],
                    [-8.893, 1.738],
                  ],
                  o: [
                    [-21.198, 45.187],
                    [-9.594, -2.887],
                    [-1.883, -16.314],
                    [5.824, -15.125],
                    [15.292, -8.684],
                    [9.741, -1.904],
                  ],
                  v: [
                    [34.697, -20.255],
                    [-9.926, -0.589],
                    [-42.538, 35.909],
                    [-29.791, -3.271],
                    [3.123, -53.785],
                    [27.118, -34.331],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: '路径 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.533333333333, 0.36862745098, 0.964705942191, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: '填充 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [317.622, 199.388], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: '变换',
            },
          ],
          nm: '组 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 244,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 13,
      ty: 4,
      nm: '“图层 14/螺旋背景”轮廓',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.681, y: 1 },
              o: { x: 0.322, y: 0 },
              t: 0,
              s: [318, 318, 0],
              to: [0, 2.667, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.688, y: 1 },
              o: { x: 0.339, y: 0 },
              t: 120,
              s: [318, 334, 0],
              to: [0, 0, 0],
              ti: [0, 2.667, 0],
            },
            { t: 240, s: [318, 318, 0] },
          ],
          ix: 2,
        },
        a: { a: 0, k: [318, 318, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-0.301, 2],
                    [-3.408, -3.984],
                    [3.103, -2.166],
                  ],
                  o: [
                    [1.479, -3.214],
                    [4.089, 3.188],
                    [-0.117, -0.137],
                  ],
                  v: [
                    [-4.678, 4.521],
                    [0.89, -3.474],
                    [-4.258, 7.458],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: '路径 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [1, 0.941176530427, 0.941176530427, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: '填充 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [248.391, 181.375], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: '变换',
            },
          ],
          nm: '组 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 244,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 14,
      ty: 4,
      nm: '“图层 15/螺旋背景”轮廓',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.681, y: 1 },
              o: { x: 0.322, y: 0 },
              t: 0,
              s: [318, 318, 0],
              to: [0.667, -3.333, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.688, y: 1 },
              o: { x: 0.339, y: 0 },
              t: 120,
              s: [322, 298, 0],
              to: [0, 0, 0],
              ti: [0.667, -3.333, 0],
            },
            { t: 240, s: [318, 318, 0] },
          ],
          ix: 2,
        },
        a: { a: 0, k: [318, 318, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [1.111, 7.915],
                    [-20.331, 19.207],
                    [-2.904, 7.683],
                    [13.07, -16.134],
                    [1.473, -8.764],
                  ],
                  o: [
                    [-0.496, -27.502],
                    [0.726, -1.536],
                    [-2.904, 19.207],
                    [-5.808, 6.146],
                    [-0.346, 1.443],
                  ],
                  v: [
                    [-12.937, 36.682],
                    [5.446, -42.292],
                    [14.885, -44.598],
                    [-3.994, 10.717],
                    [-9.823, 34.846],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: '路径 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.952941236309, 0.674509803922, 0.415686304429, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: '填充 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [198.688, 199.569], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: '变换',
            },
          ],
          nm: '组 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 244,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 15,
      ty: 4,
      nm: '“图层 16/螺旋背景”轮廓',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.681, y: 1 },
              o: { x: 0.322, y: 0 },
              t: 0,
              s: [318, 318, 0],
              to: [-0.667, 1.667, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.688, y: 1 },
              o: { x: 0.339, y: 0 },
              t: 120,
              s: [314, 328, 0],
              to: [0, 0, 0],
              ti: [-0.667, 1.667, 0],
            },
            { t: 240, s: [318, 318, 0] },
          ],
          ix: 2,
        },
        a: { a: 0, k: [318, 318, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-9.704, -7.25],
                    [2.599, -20.956],
                    [1.791, 5.195],
                  ],
                  o: [
                    [9.705, 7.25],
                    [-0.378, 0.399],
                    [-4.787, -19.517],
                  ],
                  v: [
                    [3.162, -29.03],
                    [-4.556, 31.085],
                    [-8.079, 31.085],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: '路径 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [1, 0.941176530427, 0.941176530427, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: '填充 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [240.468, 253.715], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: '变换',
            },
          ],
          nm: '组 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 244,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 16,
      ty: 4,
      nm: '“图层 17/螺旋背景”轮廓',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.681, y: 1 },
              o: { x: 0.322, y: 0 },
              t: 0,
              s: [318, 318, 0],
              to: [-2, 3, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.688, y: 1 },
              o: { x: 0.339, y: 0 },
              t: 120,
              s: [306, 336, 0],
              to: [0, 0, 0],
              ti: [-2, 3, 0],
            },
            { t: 240, s: [318, 318, 0] },
          ],
          ix: 2,
        },
        a: { a: 0, k: [318, 318, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-25.609, -8.499],
                    [-4.979, -0.772],
                    [-22.051, 47.13],
                    [64.733, 30.905],
                    [20.629, 15.453],
                    [-9.959, 42.495],
                    [-4.268, 1.545],
                    [2.845, 11.59],
                    [-9.451, -20.818],
                    [-22.977, -23.466],
                  ],
                  o: [
                    [4.979, 2.318],
                    [55.485, 13.135],
                    [-19.917, 71.081],
                    [-21.34, -10.817],
                    [-32.01, -23.178],
                    [1.422, -6.953],
                    [9.959, -3.863],
                    [8.536, 21.634],
                    [11.221, 21.772],
                    [21.74, 16.971],
                  ],
                  v: [
                    [11.472, 48.676],
                    [24.276, 57.947],
                    [147.158, -12.579],
                    [-18.405, 70.309],
                    [-78.869, 29.359],
                    [-137.199, -69.536],
                    [-119.416, -63.355],
                    [-122.972, -101.215],
                    [-92.892, -39.447],
                    [-62.196, 16.253],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: '路径 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.282352941176, 0.58431372549, 0.937254961799, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: '填充 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [357.46, 396.608], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: '变换',
            },
          ],
          nm: '组 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 244,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 17,
      ty: 4,
      nm: '“图层 18/螺旋背景”轮廓',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.681, y: 1 },
              o: { x: 0.322, y: 0 },
              t: 0,
              s: [318, 318, 0],
              to: [1.333, 2, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.688, y: 1 },
              o: { x: 0.339, y: 0 },
              t: 120,
              s: [326, 330, 0],
              to: [0, 0, 0],
              ti: [1.333, 2, 0],
            },
            { t: 240, s: [318, 318, 0] },
          ],
          ix: 2,
        },
        a: { a: 0, k: [318, 318, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-0.974, 10.509],
                    [22.063, 21.712],
                    [-3.559, 3.102],
                    [-2.846, -3.102],
                    [9.964, -48.852],
                    [2.222, 1.461],
                  ],
                  o: [
                    [5.675, -33.875],
                    [-2.847, -3.877],
                    [4.982, -4.653],
                    [25.622, 34.894],
                    [-0.712, 3.102],
                    [-3.913, -2.892],
                  ],
                  v: [
                    [6.78, 37.752],
                    [-32.383, -45.75],
                    [-34.518, -59.708],
                    [-20.284, -58.157],
                    [28.113, 61.259],
                    [21.621, 62.125],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: '路径 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.447058853449, 0.972549079446, 0.929411824544, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: '填充 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [521.26, 244.938], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: '变换',
            },
          ],
          nm: '组 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 244,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 18,
      ty: 4,
      nm: '“图层 19/螺旋背景”轮廓',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.681, y: 1 },
              o: { x: 0.322, y: 0 },
              t: 0,
              s: [318, 318, 0],
              to: [-0.333, 2, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.688, y: 1 },
              o: { x: 0.339, y: 0 },
              t: 120,
              s: [316, 330, 0],
              to: [0, 0, 0],
              ti: [-0.333, 2, 0],
            },
            { t: 240, s: [318, 318, 0] },
          ],
          ix: 2,
        },
        a: { a: 0, k: [318, 318, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-32.376, 5.513],
                    [-24.359, 14.708],
                    [-2.149, -0.774],
                    [-4.299, 4.645],
                    [40.837, 59.608],
                    [-2.15, 3.096],
                    [-5.016, -5.419],
                    [2.15, -61.93],
                    [68.062, 6.967],
                    [8.597, 1.548],
                    [24.359, 23.224],
                    [-7.881, 6.193],
                    [-10.379, -10.652],
                  ],
                  o: [
                    [27.672, -4.353],
                    [2.149, -0.774],
                    [7.164, 2.322],
                    [57.315, -59.608],
                    [-1.433, -3.096],
                    [4.298, -6.968],
                    [42.269, 40.254],
                    [-2.865, 74.317],
                    [-7.164, -0.774],
                    [-30.807, -3.871],
                    [-5.732, -5.419],
                    [14.329, -10.838],
                    [9.743, 7.045],
                  ],
                  v: [
                    [-27.313, 103.441],
                    [47.644, 68.123],
                    [54.808, 67.349],
                    [71.286, 75.865],
                    [36.181, -136.247],
                    [34.747, -146.31],
                    [54.092, -146.31],
                    [129.317, 10.837],
                    [-10.388, 146.31],
                    [-31.882, 133.924],
                    [-118.57, 106.055],
                    [-123.585, 84.38],
                    [-84.549, 95.032],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: '路径 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.968627510819, 0.145098039216, 0.521568627451, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: '填充 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [425.802, 324.867], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: '变换',
            },
          ],
          nm: '组 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 244,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 19,
      ty: 4,
      nm: '“图层 20/螺旋背景”轮廓',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.681, y: 1 },
              o: { x: 0.322, y: 0 },
              t: 0,
              s: [318, 318, 0],
              to: [-3.333, 0.667, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.688, y: 1 },
              o: { x: 0.339, y: 0 },
              t: 120,
              s: [298, 322, 0],
              to: [0, 0, 0],
              ti: [-3.333, 0.667, 0],
            },
            { t: 240, s: [318, 318, 0] },
          ],
          ix: 2,
        },
        a: { a: 0, k: [318, 318, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [13.678, 4.466],
                    [36.958, -12.362],
                    [10.661, -23.951],
                    [2.843, -23.179],
                    [1.421, -2.318],
                    [0.71, -7.727],
                    [-7.818, -13.907],
                    [2.132, 1.545],
                    [-2.842, 29.359],
                    [-31.982, 22.406],
                    [-24.165, 12.362],
                    [-21.321, -5.408],
                    [-2.132, -3.863],
                    [-7.845, -6.063],
                  ],
                  o: [
                    [-37.58, -9.049],
                    [-22.032, 7.726],
                    [-9.239, 21.633],
                    [0, 2.317],
                    [-3.554, 5.409],
                    [-0.711, 17.77],
                    [2.132, 3.863],
                    [-24.165, -12.362],
                    [3.554, -35.54],
                    [23.454, -16.225],
                    [19.189, -9.271],
                    [6.397, 1.545],
                    [4.265, 8.499],
                    [17.439, 13.223],
                  ],
                  v: [
                    [102.212, -57.395],
                    [-11.415, -67.99],
                    [-67.562, -23.951],
                    [-76.801, 44.812],
                    [-80.354, 50.992],
                    [-93.147, 66.445],
                    [-70.404, 108.938],
                    [-76.09, 111.256],
                    [-113.048, 37.858],
                    [-78.933, -60.264],
                    [-7.861, -99.667],
                    [53.26, -107.393],
                    [61.078, -95.804],
                    [85.981, -82.787],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: '路径 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.952941236309, 0.674509803922, 0.415686304429, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: '填充 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [399.089, 255.874], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: '变换',
            },
          ],
          nm: '组 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 244,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 20,
      ty: 4,
      nm: '“图层 21/螺旋背景”轮廓',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.681, y: 1 },
              o: { x: 0.322, y: 0 },
              t: 0,
              s: [318, 318, 0],
              to: [1.667, 1.667, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.688, y: 1 },
              o: { x: 0.339, y: 0 },
              t: 120,
              s: [328, 328, 0],
              to: [0, 0, 0],
              ti: [1.667, 1.667, 0],
            },
            { t: 240, s: [318, 318, 0] },
          ],
          ix: 2,
        },
        a: { a: 0, k: [318, 318, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [15.239, 4.098],
                    [9.26, 9.364],
                    [29.917, -3.901],
                    [-0.713, 0.78],
                    [-21.37, 0.781],
                    [-17.096, -3.121],
                    [6.447, -18.636],
                  ],
                  o: [
                    [-15.697, -2.29],
                    [-25.643, -27.311],
                    [-2.137, 0],
                    [18.52, -14.046],
                    [16.383, -0.78],
                    [17.096, 3.902],
                    [-1.399, 5.624],
                  ],
                  v: [
                    [43.478, 27.578],
                    [22.082, -4.365],
                    [-69.807, -2.024],
                    [-70.519, -5.925],
                    [-9.26, -25.434],
                    [39.89, -23.873],
                    [65.497, 17.393],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: '路径 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.929411824544, 0.411764735802, 0.36862745098, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: '填充 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [436.088, 163.177], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: '变换',
            },
          ],
          nm: '组 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 244,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 21,
      ty: 4,
      nm: '“图层 22/螺旋背景”轮廓',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.681, y: 1 },
              o: { x: 0.322, y: 0 },
              t: 0,
              s: [318, 318, 0],
              to: [0, 2.667, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.688, y: 1 },
              o: { x: 0.339, y: 0 },
              t: 120,
              s: [318, 334, 0],
              to: [0, 0, 0],
              ti: [0, 2.667, 0],
            },
            { t: 240, s: [318, 318, 0] },
          ],
          ix: 2,
        },
        a: { a: 0, k: [318, 318, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-2.269, -1.363],
                    [13.162, -13.992],
                    [5.118, 0],
                    [2.925, -2.332],
                    [-2.05, 10.449],
                  ],
                  o: [
                    [9.961, 14.621],
                    [-0.731, -4.664],
                    [-2.925, 0],
                    [-5.85, -10.105],
                    [1.763, -12.705],
                  ],
                  v: [
                    [-0.82, -27.616],
                    [1.097, 28.979],
                    [-1.096, 15.765],
                    [-8.409, 23.538],
                    [-0.509, -9.453],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: '路径 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.447058853449, 0.972549079446, 0.929411824544, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: '填充 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [505.131, 310.235], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: '变换',
            },
          ],
          nm: '组 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 244,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 22,
      ty: 4,
      nm: '“图层 24/螺旋背景”轮廓',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.681, y: 1 },
              o: { x: 0.322, y: 0 },
              t: 0,
              s: [318, 318, 0],
              to: [2.333, -2.667, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.688, y: 1 },
              o: { x: 0.339, y: 0 },
              t: 120,
              s: [332, 302, 0],
              to: [0, 0, 0],
              ti: [2.333, -2.667, 0],
            },
            { t: 240, s: [318, 318, 0] },
          ],
          ix: 2,
        },
        a: { a: 0, k: [318, 318, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [11.635, 0],
                    [2.182, -2.336],
                    [-2.909, 1.557],
                    [-9.436, 5.344],
                  ],
                  o: [
                    [-7.892, 8.681],
                    [-2.909, 0],
                    [1.454, -3.893],
                    [10.908, -3.114],
                    [0, 0],
                  ],
                  v: [
                    [18.446, -9.902],
                    [-11.262, 5.007],
                    [-18.534, 10.457],
                    [-11.99, 2.672],
                    [18.535, -10.457],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: '路径 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [1, 0.941176530427, 0.941176530427, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: '填充 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [370.367, 217.216], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: '变换',
            },
          ],
          nm: '组 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 244,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 23,
      ty: 4,
      nm: '“图层 25/螺旋背景”轮廓',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.681, y: 1 },
              o: { x: 0.322, y: 0 },
              t: 0,
              s: [318, 318, 0],
              to: [-2.667, -0.333, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.688, y: 1 },
              o: { x: 0.339, y: 0 },
              t: 120,
              s: [302, 316, 0],
              to: [0, 0, 0],
              ti: [-2.667, -0.333, 0],
            },
            { t: 240, s: [318, 318, 0] },
          ],
          ix: 2,
        },
        a: { a: 0, k: [318, 318, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-2.849, 9.695],
                    [-2.15, 0.775],
                    [-2.15, 0.775],
                    [-25.088, -41.084],
                    [35.123, -42.634],
                    [62.36, 48.06],
                    [-25.088, 7.752],
                    [12.186, 37.208],
                    [-53.759, 9.301],
                    [-5.734, 1.55],
                    [-7.885, 37.983],
                    [-0.717, 4.651],
                    [63.67, -13.663],
                  ],
                  o: [
                    [1.861, -0.384],
                    [3.584, -1.551],
                    [45.157, -4.651],
                    [30.105, 50.386],
                    [-56.626, 67.439],
                    [23.653, 3.876],
                    [-27.238, -17.829],
                    [40.14, 39.534],
                    [5.734, -1.551],
                    [34.406, -8.527],
                    [1.434, -6.976],
                    [9.318, -66.664],
                    [-7.306, -0.035],
                  ],
                  v: [
                    [-16.197, -139.145],
                    [-10.752, -143.405],
                    [-5.734, -138.754],
                    [104.651, -75.191],
                    [87.448, 77.516],
                    [-124.72, 88.368],
                    [-55.192, 106.197],
                    [-134.756, 44.959],
                    [10.752, 84.493],
                    [27.238, 86.043],
                    [94.616, 11.627],
                    [104.651, -3.101],
                    [-7.044, -125.866],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: '路径 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.227450995352, 0.047058827269, 0.639215686275, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: '填充 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [404.434, 333.459], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: '变换',
            },
          ],
          nm: '组 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 244,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 24,
      ty: 4,
      nm: '“图层 26/螺旋背景”轮廓',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.681, y: 1 },
              o: { x: 0.322, y: 0 },
              t: 0,
              s: [318, 318, 0],
              to: [1, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.688, y: 1 },
              o: { x: 0.339, y: 0 },
              t: 120,
              s: [324, 318, 0],
              to: [0, 0, 0],
              ti: [1, 0, 0],
            },
            { t: 240, s: [318, 318, 0] },
          ],
          ix: 2,
        },
        a: { a: 0, k: [318, 318, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [1.485, -9.186],
                    [12.223, -5.402],
                    [9.347, -10.033],
                    [-7.19, 20.066],
                    [-8.181, 3.017],
                  ],
                  o: [
                    [2.518, 15.42],
                    [-10.785, 4.631],
                    [-8.628, -18.522],
                    [3.595, -10.034],
                    [5.816, -4.551],
                  ],
                  v: [
                    [19.771, -27.769],
                    [-3.595, 1.543],
                    [-12.942, 37.817],
                    [-15.099, -27.784],
                    [8.9, -31.573],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: '路径 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.533333333333, 0.36862745098, 0.964705942191, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: '填充 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [318.734, 268.531], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: '变换',
            },
          ],
          nm: '组 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 244,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 25,
      ty: 4,
      nm: '“图层 27/螺旋背景”轮廓',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.681, y: 1 },
              o: { x: 0.322, y: 0 },
              t: 0,
              s: [318, 318, 0],
              to: [-2, -1.667, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.688, y: 1 },
              o: { x: 0.339, y: 0 },
              t: 120,
              s: [306, 308, 0],
              to: [0, 0, 0],
              ti: [-2, -1.667, 0],
            },
            { t: 240, s: [318, 318, 0] },
          ],
          ix: 2,
        },
        a: { a: 0, k: [318, 318, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0.33, 0.907],
                    [-2.698, 0],
                    [0.832, -3.168],
                  ],
                  o: [
                    [-1.143, -2.792],
                    [-0.45, 3.303],
                    [-0.061, 0.089],
                  ],
                  v: [
                    [0.019, 4.245],
                    [1.124, -5.152],
                    [0.742, 4.621],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: '路径 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [1, 0.941176530427, 0.941176530427, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: '填充 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [272.562, 306.522], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: '变换',
            },
          ],
          nm: '组 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 244,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 26,
      ty: 4,
      nm: '“图层 29/螺旋背景”轮廓',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.681, y: 1 },
              o: { x: 0.322, y: 0 },
              t: 0,
              s: [318, 318, 0],
              to: [-3.667, -1, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.688, y: 1 },
              o: { x: 0.339, y: 0 },
              t: 120,
              s: [296, 312, 0],
              to: [0, 0, 0],
              ti: [-3.667, -1, 0],
            },
            { t: 240, s: [318, 318, 0] },
          ],
          ix: 2,
        },
        a: { a: 0, k: [318, 318, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [2.28, 1.279],
                    [-1.43, 14.586],
                    [-5.915, -12.794],
                  ],
                  o: [
                    [-11.847, -8.803],
                    [7.151, 12.283],
                    [0.081, 0.565],
                  ],
                  v: [
                    [8.001, 19.116],
                    [-8.851, -20.395],
                    [9.935, 16.965],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: '路径 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [1, 0.941176530427, 0.941176530427, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: '填充 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [291.751, 345.666], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: '变换',
            },
          ],
          nm: '组 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 244,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 27,
      ty: 4,
      nm: '“图层 30/螺旋背景”轮廓',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.681, y: 1 },
              o: { x: 0.322, y: 0 },
              t: 0,
              s: [318, 318, 0],
              to: [-2.667, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.688, y: 1 },
              o: { x: 0.339, y: 0 },
              t: 120,
              s: [302, 318, 0],
              to: [0, 0, 0],
              ti: [-2.14, 0.917, 0],
            },
            { t: 240, s: [318, 318, 0] },
          ],
          ix: 2,
        },
        a: { a: 0, k: [318, 318, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-20.167, -3.534],
                    [-4.281, 0.778],
                    [-17.128, 5.451],
                    [0, 31.153],
                    [24.979, -21.028],
                    [34.97, 38.942],
                    [0, 3.116],
                    [6.423, 7.009],
                    [-10.702, -6.487],
                  ],
                  o: [
                    [4.279, -0.199],
                    [18.556, -3.116],
                    [31.401, -10.904],
                    [7.85, 31.932],
                    [-36.397, 30.375],
                    [-3.569, -3.115],
                    [1.427, -10.125],
                    [11.419, 5.452],
                    [13.677, 8.272],
                  ],
                  v: [
                    [-16.054, 32.521],
                    [-3.212, 32.322],
                    [48.887, 18.302],
                    [81.716, -65.033],
                    [62.446, 24.533],
                    [-75.292, 26.091],
                    [-71.724, 15.186],
                    [-89.566, -6.62],
                    [-56.026, 11.548],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: '路径 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.952941236309, 0.674509803922, 0.415686304429, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: '填充 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [396.314, 377.358], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: '变换',
            },
          ],
          nm: '组 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 244,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 28,
      ty: 4,
      nm: '“图层 31/螺旋背景”轮廓',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.681, y: 1 },
              o: { x: 0.322, y: 0 },
              t: 0,
              s: [318, 318, 0],
              to: [1.333, 3, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.688, y: 1 },
              o: { x: 0.339, y: 0 },
              t: 120,
              s: [326, 336, 0],
              to: [0, 0, 0],
              ti: [1.333, 3, 0],
            },
            { t: 240, s: [318, 318, 0] },
          ],
          ix: 2,
        },
        a: { a: 0, k: [318, 318, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [2.895, 6.731],
                    [18.264, 7.738],
                    [-2.108, 3.869],
                    [-2.81, -1.548],
                    [-14.05, -14.703],
                    [6.776, -6.81],
                  ],
                  o: [
                    [-6.293, -22.958],
                    [-2.81, -0.774],
                    [1.405, -2.321],
                    [16.157, 9.286],
                    [4.214, 5.416],
                    [-2.475, 1.608],
                  ],
                  v: [
                    [16.128, 20.881],
                    [-30.909, -14.458],
                    [-34.421, -22.969],
                    [-27.397, -26.064],
                    [21.777, 1.019],
                    [29.753, 23.305],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: '路径 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.447058853449, 0.972549079446, 0.929411824544, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: '填充 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [449.106, 226.353], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: '变换',
            },
          ],
          nm: '组 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 244,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 29,
      ty: 4,
      nm: '“图层 32/螺旋背景”轮廓',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.681, y: 1 },
              o: { x: 0.322, y: 0 },
              t: 0,
              s: [318, 318, 0],
              to: [1, 1.333, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.688, y: 1 },
              o: { x: 0.339, y: 0 },
              t: 120,
              s: [324, 326, 0],
              to: [0, 0, 0],
              ti: [1, 1.333, 0],
            },
            { t: 240, s: [318, 318, 0] },
          ],
          ix: 2,
        },
        a: { a: 0, k: [318, 318, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-34.002, 25.131],
                    [-14.335, 16.26],
                    [-0.716, 4.646],
                    [35.836, 26.327],
                    [-3.584, 2.322],
                    [-2.867, -1.548],
                    [-21.501, -21.681],
                    [33.685, -31.746],
                    [18.635, -10.84],
                    [13.617, 3.871],
                    [0.717, 5.42],
                    [-2.537, 1.204],
                  ],
                  o: [
                    [17.624, -11.352],
                    [4.3, -3.871],
                    [8.601, -52.652],
                    [-3.584, -2.322],
                    [2.867, -2.323],
                    [27.952, 9.292],
                    [35.119, 34.843],
                    [-15.051, 13.938],
                    [-12.184, 6.969],
                    [-4.3, -1.549],
                    [0, -3.098],
                    [7.47, -4.488],
                  ],
                  v: [
                    [-14.757, 70.973],
                    [24.369, 21.68],
                    [37.986, 13.163],
                    [-47.303, -93.691],
                    [-47.303, -103.756],
                    [-37.986, -104.531],
                    [37.986, -61.944],
                    [32.253, 70.461],
                    [-22.218, 98.336],
                    [-62.354, 102.208],
                    [-73.105, 92.142],
                    [-68.418, 84.743],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: '路径 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.968627510819, 0.145098039216, 0.521568627451, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: '填充 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [448.982, 308.385], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: '变换',
            },
          ],
          nm: '组 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 244,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 30,
      ty: 4,
      nm: '“图层 33/螺旋背景”轮廓',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.681, y: 1 },
              o: { x: 0.322, y: 0 },
              t: 0,
              s: [318, 318, 0],
              to: [-1, -1, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.688, y: 1 },
              o: { x: 0.339, y: 0 },
              t: 120,
              s: [312, 312, 0],
              to: [0, 0, 0],
              ti: [-1, -1, 0],
            },
            { t: 240, s: [318, 318, 0] },
          ],
          ix: 2,
        },
        a: { a: 0, k: [318, 318, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [7.109, -3.562],
                    [18.749, -10.816],
                    [2.885, -16.996],
                    [5.769, -22.404],
                    [-8.653, -9.271],
                    [-0.721, 30.902],
                    [-31.007, 22.404],
                    [-4.327, -2.317],
                    [-5.868, 0.412],
                  ],
                  o: [
                    [-18.462, 10.81],
                    [-14.422, 9.271],
                    [-3.605, 21.632],
                    [-2.884, 13.133],
                    [-36.055, 2.318],
                    [0, -40.173],
                    [3.606, -3.09],
                    [4.327, 3.091],
                    [12.955, 1.253],
                  ],
                  v: [
                    [51.827, -71.842],
                    [-6.296, -46.353],
                    [-34.419, -5.408],
                    [-32.256, 57.941],
                    [-8.459, 84.98],
                    [-58.215, 8.497],
                    [7.405, -84.208],
                    [18.222, -80.346],
                    [34.185, -81.53],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: '路径 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.227450995352, 0.047058827269, 0.639215686275, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: '填充 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [373.004, 279.05], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: '变换',
            },
          ],
          nm: '组 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 244,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 31,
      ty: 4,
      nm: '“图层 34/螺旋背景”轮廓',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.681, y: 1 },
              o: { x: 0.322, y: 0 },
              t: 0,
              s: [318, 318, 0],
              to: [-2.333, -2.333, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.688, y: 1 },
              o: { x: 0.339, y: 0 },
              t: 120,
              s: [304, 304, 0],
              to: [0, 0, 0],
              ti: [-2.333, -2.333, 0],
            },
            { t: 240, s: [318, 318, 0] },
          ],
          ix: 2,
        },
        a: { a: 0, k: [318, 318, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [7.964, -3.435],
                    [0.708, 0.776],
                    [20.508, -20.177],
                    [-21.922, 7.76],
                    [-3.546, -11.708],
                  ],
                  o: [
                    [-1.343, 0.871],
                    [-24.751, -30.264],
                    [8.486, -24.833],
                    [9.901, -3.104],
                    [1.996, 4.38],
                  ],
                  v: [
                    [33.109, 9.992],
                    [28.937, 10.863],
                    [-41.073, 25.609],
                    [12.672, -22.505],
                    [37.434, -6.141],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: '路径 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.929411824544, 0.411764735802, 0.36862745098, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: '填充 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [379.881, 201.069], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: '变换',
            },
          ],
          nm: '组 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 244,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 32,
      ty: 2,
      nm: '椭圆形.png',
      cl: 'png',
      refId: 'image_0',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [318, 318, 0], ix: 2 },
        a: { a: 0, k: [351, 339, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      ip: 0,
      op: 240,
      st: 0,
      bm: 0,
    },
  ],
  markers: [],
};
